"use strict";
/* eslint-disable max-len */
/* eslint-disable no-console */
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultLog = exports.TaggedLog = exports.LogLevel = void 0;
var LogLevel;
(function (LogLevel) {
    /* eslint-disable @typescript-eslint/naming-convention */
    LogLevel["INTERNAL"] = "INTERNAL";
    LogLevel["DEBUG"] = "DEBUG";
    LogLevel["INFO"] = "INFO";
    LogLevel["WARN"] = "WARN";
    LogLevel["ERROR"] = "ERROR";
    LogLevel["FATAL"] = "FATAL";
})(LogLevel = exports.LogLevel || (exports.LogLevel = {}));
var TaggedLog = /** @class */ (function () {
    function TaggedLog(log, tag) {
        this.log = log;
        this.tag = tag;
    }
    TaggedLog.prototype.send = function (level, text) {
        return this.log.send(level, this.tag, text);
    };
    TaggedLog.prototype.sendObject = function (level, text, obj) {
        return this.log.sendObject(level, this.tag, text, obj);
    };
    TaggedLog.prototype.setLogLevel = function (level) {
        return this.log.setLogLevel(level);
    };
    TaggedLog.prototype.internal = function (text, obj) {
        return this.log.internal(this.tag, text, obj);
    };
    TaggedLog.prototype.debug = function (text, obj) {
        return this.log.debug(this.tag, text, obj);
    };
    TaggedLog.prototype.info = function (text, obj) {
        return this.log.info(this.tag, text, obj);
    };
    TaggedLog.prototype.warn = function (text, obj) {
        return this.log.warn(this.tag, text, obj);
    };
    TaggedLog.prototype.error = function (text, obj) {
        return this.log.error(this.tag, text, obj);
    };
    TaggedLog.prototype.fatal = function (text, obj) {
        return this.log.fatal(this.tag, text, obj);
    };
    return TaggedLog;
}());
exports.TaggedLog = TaggedLog;
var DefaultLog = /** @class */ (function () {
    function DefaultLog() {
        this.prefix = 'Log';
        this.level = LogLevel.WARN;
        this.useFancyStyling = DefaultLog.canUseFancyStyling();
    }
    DefaultLog.canUseFancyStyling = function () {
        if (typeof window === 'undefined') {
            return false;
        }
        var isFirefox = /firefox/i.test(window.navigator.userAgent);
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var consoleStyles = !!window.chrome || !!isFirefox;
        return consoleStyles;
    };
    /**
     * Sets current logging level. Messages below this log level will be ignored.
     */
    DefaultLog.prototype.setLogLevel = function (level) {
        this.level = level;
    };
    DefaultLog.prototype.setLogPrefix = function (prefix) {
        this.prefix = prefix;
    };
    DefaultLog.prototype.internal = function (tag, text, obj) {
        if (obj != undefined) {
            this.sendObject(LogLevel.INTERNAL, tag, text, obj);
        }
        else {
            this.send(LogLevel.INTERNAL, tag, text);
        }
    };
    DefaultLog.prototype.debug = function (tag, text, obj) {
        if (obj != undefined) {
            this.sendObject(LogLevel.DEBUG, tag, text, obj);
        }
        else {
            this.send(LogLevel.DEBUG, tag, text);
        }
    };
    DefaultLog.prototype.info = function (tag, text, obj) {
        if (obj != undefined) {
            this.sendObject(LogLevel.INFO, tag, text, obj);
        }
        else {
            this.send(LogLevel.INFO, tag, text);
        }
    };
    DefaultLog.prototype.warn = function (tag, text, obj) {
        if (obj != undefined) {
            this.sendObject(LogLevel.WARN, tag, text, obj);
        }
        else {
            this.send(LogLevel.WARN, tag, text);
        }
    };
    DefaultLog.prototype.error = function (tag, text, obj) {
        if (obj != undefined) {
            this.sendObject(LogLevel.ERROR, tag, text, obj);
        }
        else {
            this.send(LogLevel.ERROR, tag, text);
        }
    };
    DefaultLog.prototype.fatal = function (tag, text, obj) {
        if (obj != undefined) {
            this.sendObject(LogLevel.FATAL, tag, text, obj);
        }
        else {
            this.send(LogLevel.FATAL, tag, text);
        }
    };
    /**
     * Logs a message to the console
     */
    DefaultLog.prototype.send = function (level, tag, text) {
        if (level < this.level || level == LogLevel.DEBUG || level == LogLevel.INTERNAL) {
            return;
        }
        var fn = console.log;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore ignoring .error already defined
        // TODO
        if ((console.error && level == LogLevel.ERROR) || (console.error && level == LogLevel.FATAL)) {
            fn = console.error;
        }
        if (console.warn && level == LogLevel.WARN) {
            fn = console.warn;
        }
        if (console.info && level == LogLevel.INFO) {
            fn = console.info;
        }
        if (console.debug && level == LogLevel.DEBUG) {
            fn = console.debug;
        }
        if (console.debug && level == LogLevel.INTERNAL) {
            fn = console.debug;
        }
        // Binding back to console because iOS Safari is weird
        if (this.useFancyStyling) {
            var str = '%c' + this.prefix + '%c' + level;
            str += '%c %c' + tag + '%c' + text;
            var levelColor = {
                INTERNAL: '#999999; color: white;',
                DEBUG: '#454F5B; color: white;',
                INFO: '#007ACE; color: white;',
                WARN: '#EEC200; color: white;',
                ERROR: '#BF0711; color: white;',
                FATAL: 'linear-gradient(to top, #EEC200 0, #BF0711 100%); color: white;'
            }[level];
            var styles = [
                'background: #202E78; border-top-left-radius: 4px; border-bottom-left-radius: 4px; padding: 0 8px;color: white',
                'width: 55px; text-align: center; padding: 0 8px; border-bottom-right-radius: 4px; border-top-right-radius: 4px;background:' + levelColor,
                'padding: 0 2px;',
                'background: #084E8A;padding:0 8px; color: white;border-radius: 8px;',
                'padding:0 8px;'
            ];
            fn.bind(console).apply(void 0, __spreadArray([str], __read(styles), false));
        }
        else {
            fn.bind(console)("[".concat(this.prefix, "] ").concat(level, ": [").concat(tag, "] ").concat(text));
        }
    };
    /**
     * Log an object.
     */
    DefaultLog.prototype.sendObject = function (level, tag, text, obj) {
        if (level < this.level) {
            return;
        }
        var fn = console.log;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore ignoring .error already defined
        // TODO
        if ((console.error && level == LogLevel.ERROR) || (console.error && level == LogLevel.FATAL)) {
            fn = console.error;
        }
        if (console.warn && level == LogLevel.WARN) {
            fn = console.warn;
        }
        if (console.info && level == LogLevel.INFO) {
            fn = console.info;
        }
        if (console.debug && level == LogLevel.DEBUG) {
            fn = console.debug;
        }
        if (console.debug && level == LogLevel.INTERNAL) {
            fn = console.debug;
        }
        // Binding back to console because iOS Safari is weird
        if (this.useFancyStyling) {
            var str = '%c' + this.prefix + '%c' + level;
            str += '%c %c' + tag + '%c' + text + ' %o';
            var levelColor = {
                INTERNAL: '#999999; color: white;',
                DEBUG: '#454F5B; color: white;',
                INFO: '#007ACE; color: white;',
                WARN: '#EEC200; color: white;',
                ERROR: '#BF0711; color: white;',
                FATAL: 'linear-gradient(to top, #EEC200 0, #BF0711 100%); color: white;'
            }[level];
            var styles = [
                'background: #202E78; border-top-left-radius: 4px; border-bottom-left-radius: 4px; padding: 0 8px;color: white',
                'width: 55px; text-align: center; padding: 0 8px; border-bottom-right-radius: 4px; border-top-right-radius: 4px;background:' + levelColor,
                'padding: 0 2px;',
                'background: #084E8A;padding:1px 8px; color: white;border-radius: 8px;',
                'padding-left: 8px;'
            ];
            fn.bind(console).apply(void 0, __spreadArray(__spreadArray([str], __read(styles), false), [obj], false));
        }
        else {
            fn.bind(console)("[".concat(this.prefix, "] ").concat(level, ": [").concat(tag, "] ").concat(text), obj);
        }
    };
    return DefaultLog;
}());
exports.DefaultLog = DefaultLog;
//# sourceMappingURL=logging.js.map